import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import { ReactComponent as MenuIcon } from '../../../assets/images/menu.svg'
import { useOnClickOutside } from '../../../hooks/useOnClickOutside'

const StyledMenuIcon = styled(MenuIcon)`
  path {
    stroke: ${({ theme }) => theme.text1};
  }

  cursor: pointer;
`

const MenuItem = styled.div`
  cursor: pointer;
  font-weight: 500;
  padding: 5px 0;

  &:hover {
    color: #a97eff;
  }
`

const Menu = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const menuBtnNode = useRef(null)
  const menuToggler = () => setMenuOpen(prev => !prev)

  useOnClickOutside(menuBtnNode, menuOpen ? menuToggler : undefined)

  return (
    <div style={{ position: 'absolute', right: '20px' }} onClick={() => setMenuOpen(prev => !prev)}>
      <StyledMenuIcon />
      <div style={{ position: 'absolute', right: '1px' }}>
        <div
          style={{
            backgroundColor: '#1B182B',
            borderRadius: '8px',
            padding: '10px 15px',
            display: menuOpen ? 'block' : 'none'
          }}
        >
          <MenuItem>Info</MenuItem>
          <MenuItem>Opensea</MenuItem>
        </div>
      </div>
    </div>
  )
}

export default Menu
